<template>
  <div class="red-bar">
    <div class="top">
      <!-- <span v-if="!room" @click="$emit('switch', 'off')"><img class="onoff" src="../img/on-ui.svg" alt="Switch back to old style" title="Switch back to old style" /></span> -->
      <!-- <span v-if="room" @click="$emit('switch', 'off')"><img class="onoff" src="../img/on-ui.svg" alt="Switch back to old style" title="Switch back to old style" /></span> -->
      <span @click="$emit('earthflow'); $emit('bar', 'earthcourse')"><img class="earth" src="../img/white-hat.svg" alt="Show Earth" title="Show Earth" /></span>
      <span @click="$emit('overlay', 'admin');"><img class="earth" src="../img/key.svg" alt="Show Earth" title="Admin" /></span>
      <!-- <span @click="$emit('main', 'chat'); $emit('bar', 'earthcourse'); $emit('roomTitle', 'Demo_Fashion_Design_And_Creation')"><img class="earth" src="../img/white-chat.svg" alt="Show Earth" title="Show Earth" /></span> -->
    </div>
    <div class="bottom">
      <img v-if="roomID" @click="$emit('main', 'chat'); $emit('bar', 'online')" src="../img/online-users-white.svg" class="icon-online" alt="Online Users" title="Online Users">
      <img @click="$emit('main', 'chat'); $emit('bar', 'favourite')" src="../img/heart-wire.svg" alt="Favourite Room" title="Favourite Room">
      <img @click="$emit('main', 'chat'); $emit('bar', 'search')"  src="../img/search.svg" alt="Search Room" title="Search Room">
      <img @click="$emit('main', 'chat'); $emit('bar', 'create')" src="../img/create-room.svg" alt="Create Room" title="Create Room">
    </div>
  </div>
</template>

<script>
// import * as eAPI from './eAPI.js'
export default {
  props: {
    roomID: {},
    room: {}
  },
  methods: {
    // logout () {
    //   // eAPI.logout()
    // }
  }
}
</script>

<style scoped>
.red-bar{
  height: 100%;
  width: 55px;
  display: none;
  background-color: #A71625;
}
.onoff{
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.earth{
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin-top: 5px;
}

@media screen and (min-width: 767px) {
  .red-bar{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .top {
    flex-direction: column;
    margin: 10px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bottom {
    flex-direction: column;
    margin: 10px 0px;
    display: flex;
    justify-content: center;
  }
  .bottom > img {
    cursor: pointer;
    margin: 10px;
    margin-top: 0px;
  }
}

.bottom img.icon-online{
  cursor: pointer;
  width: 29px;
  margin: 0px auto;
  margin-bottom: 10px;
}
</style>
